import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import '../enquiry-public.css';

export default function PublicEnquiryLayout() {
  useEffect(() => {
    document.body.classList.add('public-enquiry-page');
    return () => document.body.classList.remove('public-enquiry-page');
  }, []);

  return (
    <div className="layout public-layout">
      <header className="site-header">
        <div className="container header-inner">
          <div>
            <p className="brand-tag">DCT Academy</p>
            <h1 className="brand-title">Student Enquiry Form</h1>
            <p className="brand-sub">
              Full Stack Development Training & Placement · MERN · Java Spring Boot
            </p>
          </div>
        </div>
      </header>
      <main className="container main-content">
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="container">
          <p>DCT Academy — Full Stack Development Training & Placement</p>
        </div>
      </footer>
    </div>
  );
}
